import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ShieldCheck } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/compliance')({
    staticData: {
        breadcrumb: {
            title: 'Compliance',
            inactive: true,
        },
        roles: ['user', 'shared_edit_user', 'org_admin', 'training_manager'],
        modules: ['compliance'],
        restrictToEmployee: false,
        ui: {
            icon: ShieldCheck,
        },
    },
    component: Outlet,
});
